import { MenuItem, Select, SelectChangeEvent, SxProps } from '@mui/material';
import { useStore } from "@priolo/jon";
import { FunctionComponent, useEffect } from 'react';
import chatSo from 'stores/copilot/chat';
import { ZeroGPTAgents } from 'types/copilot/Agent';



interface Props {
	sx?: SxProps
}

const AgentSelector: FunctionComponent<Props> = ({
	sx,
}) => {

	// STORES
	useStore(chatSo);


	// HOOKS
	useEffect(() => {
		if (chatSo.state.currentAgent != null) return
		chatSo.setCurrentAgent(ZeroGPTAgents[0].code)
		chatSo.updateTherads()
	}, [])


	// HANDLERS
	const handleChange = (event: SelectChangeEvent<string>) => {
		const agentCode = event.target.value
		chatSo.setCurrentAgent(agentCode)
		chatSo.updateTherads()
	}


	// RENDER
	return (
		<Select sx={sx}
			value={chatSo.state.currentAgent}
			onChange={handleChange}
		>
			{ZeroGPTAgents.map((agent) => (
				<MenuItem key={agent.code} value={agent.code}>
					{agent.name}
				</MenuItem>
			))}
		</Select>
	);
};

export default AgentSelector